/*
 * Asking for a route: through the routing worker when the browser has
 * workers, else on the main thread (the same engine, loaded lazily), else
 * not at all -- the map then draws the straight line it always has.
 */
let worker = null;    // null: not made yet; false: none to be had
let seq = 0;
const waiting = new Map();

function failAll(status) {
  for (const resolve of waiting.values()) resolve({ status });
  waiting.clear();
}

function getWorker() {
  if (worker !== null) return worker;
  if (typeof Worker === 'undefined') {
    worker = false;
    return worker;
  }
  try {
    worker = new Worker(new URL('./routing-worker.js', import.meta.url), { type: 'module', name: 'routing' });
    worker.onmessage = (event) => {
      const resolve = waiting.get(event.data?.id);
      if (resolve) {
        waiting.delete(event.data.id);
        resolve(event.data);
      }
    };
    worker.onerror = () => {
      worker = false;
      failAll('unavailable');
    };
  } catch (e) {
    worker = false;
  }
  return worker;
}

/** {status, route?, ...} for {pointerUrl, start, target, mode}. Never rejects. */
export function requestRoute(request) {
  const w = getWorker();
  if (!w) {
    return import('./engine').then((m) => m.route(request)).catch(() => ({ status: 'unavailable' }));
  }
  seq += 1;
  const id = seq;
  return new Promise((resolve) => {
    waiting.set(id, resolve);
    w.postMessage({ id, ...request });
  });
}

/** For tests: forget the worker so the next request makes it again. */
export function resetRoutingClient() {
  if (worker && typeof worker.terminate === 'function') worker.terminate();
  worker = null;
  waiting.clear();
}
